import { type ReactNode } from 'react';
import { Avatar } from '@/components/ui/avatar';
import { HealedHeartMark } from '@/components/ui/healed-heart-mark';
import type { PodiumSlot } from '../hooks/use-bonus-history';
import { formatUSD } from '../utils/payment-formatters';

type SlotNameProps = { name: string; isMe: boolean; redeemed: boolean };

function SlotName({ name, isMe, redeemed }: SlotNameProps): ReactNode {
  return (
    <p
      className={`flex items-baseline gap-1 text-xs leading-tight ${
        isMe ? 'font-medium text-brand-red' : 'text-text-primary'
      }`}
    >
      {name}
      {redeemed && <HealedHeartMark />}
      {isMe && <span className="ml-1 text-[10px] font-normal">· Tú</span>}
    </p>
  );
}

export function RankingSlotCell({
  slot,
  userId,
}: {
  slot: PodiumSlot | undefined;
  userId: string;
}): ReactNode {
  if (!slot) return <span className="text-xs text-text-tertiary/40">—</span>;
  const isMe = slot.member_id === userId;
  const redeemed = !!slot.has_used_redemption && !!slot.redemption_passed_at;
  return (
    <div className="flex items-center gap-sm">
      <Avatar size="xxs" name={slot.first_name} src={slot.photo} />
      <div>
        <SlotName name={slot.first_name} isMe={isMe} redeemed={redeemed} />
        <p className="font-mono text-[10px] tabular-nums text-text-tertiary">
          {slot.leads} · {formatUSD(slot.amount)}
        </p>
      </div>
    </div>
  );
}
